module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_0_0@3x.4cbf4cba.png";